import { useReducer } from "react"
import { size, omit, chain } from "lodash"

export default function useRowSelector(rows) {
  const [selectedRows, dispatchSelect] = useReducer((state, { type, id, checked }) => {
    switch (type) {
      case "single":
        if (checked) {
          return {
            ...state,
            [id]: true,
          }
        } else {
          return omit(state, id)
        }
      case "all":
        if (checked) {
          return chain(rows)
            .filter("deletable")
            .keyBy("key")
            .mapValues(() => true)
            .value()
        } else {
          return {}
        }
      default:
        return state
    }
  }, {})

  const rowCount = chain(rows)
    .filter("deletable")
    .size()
    .value()
  const numSelected = size(selectedRows, row => row)

  return [selectedRows, rowCount, numSelected, dispatchSelect]
}
